import { atom, useRecoilState } from 'recoil';

/**
 * This file contains UI state related to recordings.
 */

export type RecordingUIState =
  | 'starting3'
  | 'starting2'
  | 'starting1'
  | 'saved'
  | null;
const recordingUIState = atom<RecordingUIState>({
  key: 'recording-ui',
  default: null,
});
/**
 * Holds additional recording UI states for countdown.
 */
export const useRecordingUI = () => useRecoilState(recordingUIState);

const leaveWhileRecordingModalState = atom<boolean>({
  key: 'leave-while-recording-modal-state',
  default: false,
});
/**
 * Used to control visibility of LeaveWhileRecordingModal.
 */
export const useLeaveWhileRecordingModal = () =>
  useRecoilState(leaveWhileRecordingModalState);

const recordingErrorModalState = atom<boolean>({
  key: 'recording-error-modal-state',
  default: false,
});
/**
 * Used to control visibility of RecordingErrorModal.
 */
export const useRecordingErrorModal = () =>
  useRecoilState(recordingErrorModalState);

const startRecordingModalState = atom<boolean>({
  key: 'start-recording-modal-state',
  default: false,
});
/**
 * Used to control visibility of StartRecordingModal.
 */
export const useStartRecordingModal = () =>
  useRecoilState(startRecordingModalState);
